import React from 'react';
import { Box, Button, Container, Link, Grid, Paper, Typography, Stack } from '@mui/material';

import {FaGithub, FaTwitter, FaFacebook} from "react-icons/fa";
import {GrMail} from "react-icons/gr";

import {createTheme, ThemeProvider} from "@mui/material";
import { styled } from '@mui/material/styles';

import footerBackground from '../assets/footer_bg.png';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: (theme.vars ?? theme).palette.text.secondary,
  flexGrow: 1,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));



export default function Footer(){

    // function handleNavigation(e){
    //     e.preventDefault();
    // }

    return(
        <Paper 
            component ="footer"
            square variant='outlined'

            sx={{
                position: 'fixed',
                bottom: 0,
                marginTop: 'calc(10% + 60px)',
                width: '100%',
                height: '80px', // Sets the exact height
                fontSize: '0.875rem',
                textAlign: 'center',
            }}    
        >



            <Box 
                px={{xs:3, sm:10}}
                py={{xs:5, sm:3}}
                pt={{xs:5, sm:3}}
                // bgcolor="text.secondary" color="white"
                bgcolor="#808080" color="white"
                sx={{
                    backgroundImage: `url("../assets/footer_bg.png")`
                }}


                >

                <Container maxWidth="lg">

                    <Grid container spacing={2}   alignItems="center" justifyContent="center">
                        <Grid item xs={12} sm={1} />

                        <Grid item xs={12} sm={3}>
                            <Box   
                            borderBottom={0}>

                                <typography variant="caption" align="center">
                                   School Address<br></br>400 E Moore St, Apex, NC 27502
                                </typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                        <Box borderBottom={0} borderLeft={1} borderRight={1}>
    
                                <typography variant="caption" align="center">
                                    © {new Date().getFullYear()} Triangle Chinese Language School. <br/> All rights reserved.
                                </typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={3}>


                        <Box borderBottom={0} borderLeft={0} borderRight={0} >    
                            <Grid container direction="row"  alignItems="center" justifyContent="center" spacing={2}>
                                    
                                    <Grid item xs={12} sm={3} >
                                        <a href="https://www.facebook.com/racl1995/" target='_blank'>
                                            <FaFacebook size={30}/>
                                        </a>
                                    </Grid>

                                    <Grid item xs={12} sm={3} >
                                        <a href="https://x.com/raclsocial?lang=en" target='_blank'>
                                            <FaTwitter size={30}/>
                                        </a>
                                    </Grid>
                                            
                                    <Grid item xs={12} sm={3}>
                                        <a href='mailTo:racl@gmail.com' target='_blank'>
                                            <GrMail  size={30}/></a>
                                    </Grid>

                                    <Grid item xs={12} sm={3}>
                                        <a href="/documents/racl_wechat_qr_code.jpg" target='_blank'>
                                            <img src ="/documents/racl_wechat_qr_code.jpg" alt="wechat" width={48}  height={48} />
                                        </a>
                                    </Grid>

                            
                            </Grid>
                        </Box>

                        </Grid>
                        <Grid item xs={12} sm={1} />



                    </Grid>



                </Container>
            </Box>

        </Paper>

    );
}